var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lockedType === 'align')?_c('div',{staticClass:"cancel-block-align"},[(_vm.allowAlignCancel)?_c('button',{staticClass:"btn btn-default",on:{"click":_vm.cancelAlign}},[_c('i',{staticClass:"glyphicon glyphicon-remove-circle"})]):_vm._e()]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2310dc28","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/block/LockedBlockActions.vue
// module id = 989
// module chunks = 6